import { useEffect } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const HEARTBEAT_INTERVAL_MS = 30_000;  // alle 30s

/**
 * Sendet einen kleinen Heartbeat ans Backend, solange der User eingeloggt ist
 * und das Browser-Tab im Vordergrund ist. Wird vom `Layout`-Component
 * eingehängt — damit alle authentifizierten Routen automatisch tracken.
 */
export default function useHeartbeat() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user || user === false) return;

    let cancelled = false;
    const ping = async () => {
      if (cancelled) return;
      if (typeof document !== "undefined" && document.hidden) return; // pause when tab hidden
      try {
        await api.post("/users/me/heartbeat");
      } catch (_e) { /* ignore — admin will see "offline" anyway */ }
    };

    ping(); // initial ping right away
    const interval = setInterval(ping, HEARTBEAT_INTERVAL_MS);
    const onVisibility = () => { if (!document.hidden) ping(); };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [user]);
}
